/**
 * @generated SignedSource<<5c25cf6ccaf4146867aa88b134bc8399>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WorkspaceTodoLinkProductMutation$variables = {
  productId: string;
  todoWorkspaceId: string;
};
export type WorkspaceTodoLinkProductMutation$data = {
  readonly todoWorkspace: {
    readonly linkProduct: {
      readonly id: string;
    };
  };
};
export type WorkspaceTodoLinkProductMutation = {
  response: WorkspaceTodoLinkProductMutation$data;
  variables: WorkspaceTodoLinkProductMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "todoWorkspaceId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "todoWorkspaceId"
      }
    ],
    "concreteType": "TodoWorkspaceMutation",
    "kind": "LinkedField",
    "name": "todoWorkspace",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "productId",
            "variableName": "productId"
          }
        ],
        "concreteType": "TodoWorkspace",
        "kind": "LinkedField",
        "name": "linkProduct",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceTodoLinkProductMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceTodoLinkProductMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "121e53b07494e6f710a4991705869bb6",
    "id": null,
    "metadata": {},
    "name": "WorkspaceTodoLinkProductMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceTodoLinkProductMutation(\n  $productId: ID!\n  $todoWorkspaceId: ID!\n) {\n  todoWorkspace(id: $todoWorkspaceId) {\n    linkProduct(productId: $productId) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "acc42823b46b7ca1ee3807aad33767eb";

export default node;
